import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MAX_PAGE_SIZE } from '@cbridge-utils/datagrid';
import { SymbolAction } from '../symbol.action';
import { fetchBaseSymbolsRecursively } from '../_operators/fetchBaseSymbolsRecursively';
import { SymbolTranslator } from '../symbol.translator';

type IDependencies = IClientApiDependencySegment;

export const loadBaseSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.loadBaseSymbols.started),
  mergeMap((params) => {
    const { search } = params;

    return fetchBaseSymbolsRecursively(
      {
        limit: MAX_PAGE_SIZE,
        skip: 0,
        search,
      },
      dependencies,
    ).pipe(
      mergeMap((symbols) => {
        return [
          SymbolAction.loadBaseSymbols.done({ params, result: symbols.map(SymbolTranslator.fromApiExcludedDetails) }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.loadBaseSymbols.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
